<template>
  <custom-dialog width="900px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('dms_opencardDialog.RFIDka_mian_bian_hao')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
      </el-form>
      <custom-table v-model="selectList" type="checkbox" :data="tableList" :index="true" tableCode="opencard" @filter="filterChange" @sort="sortChange"></custom-table>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      selectList: [],
      formSearch: {
        deviceId: '',
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
      },
      tableList: [],
      totalRows: 0,
    };
  },
  mounted() {
    this.getTableList();
  },
  methods: {
    // 获取表格数据列表
    getTableList: function () {
      this.formSearch.deviceId = this.model.deviceId;
      this.$getJSON(apis.bootCardUnbindPage, this.formSearch).then((res) => {
        const list = res.data.list;
        list.forEach((item) => {
          item.isExists = !!this.model.row.find(t => t.cardId === item.cardId);
        });
        this.tableList = list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 确认保存
    confirm: function () {
      this.$emit('success', this.selectList);
    },
  },
};
</script>

<style lang="scss"></style>
